<template>
  <div class="flex rounded-xl flex-col items-start pt-8 px-8 pb-0">
    <img v-if="headerImage" :src="headerImage" alt="No image" />
    <h2
      ref="modalHeaderTitle"
      class="text-slate-800 text-lg dark:text-slate-100"
    >
      {{ headerTitle }}
    </h2>
    <div
      v-if="headerContent"
      ref="modalHeaderContent"
      class="w-full break-words text-slate-600 mt-2 text-base dark:text-slate-300"
    >
      {{ headerContent }}
      <div
        v-if="headerContentValue"
        class="w-full break-words text-slate-600 mt-2 text-base dark:text-slate-300"
      >
        {{ headerContentValue }}
      </div>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    headerTitle: {
      type: String,
      default: '',
    },
    headerContent: {
      type: String,
      default: '',
    },
    headerContentValue: {
      type: String,
      default: '',
    },
    headerImage: {
      type: String,
      default: '',
    },
  },
};
</script>
